import React, { Component } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { Link, withRouter } from "react-router-dom";
import "../../scss/auth.scss"
import { resetPassword, userLogin } from "../../network/auth.network";
import { connect } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.action";
import localization from '../../Localization/Localization.json'
import logo from "../../assets/done.png" 
import authBG from "../../assets/auth.png" 


class ResetPassword extends Component {
  constructor() {
    super();
    this.state = {
      btnLoading: false,
      isLoginValid: false,
      newPassword: ''
    };
  }

  onFinish = (values) => {
    this.setState({ newPassword: values.password })
    this.setState({ btnLoading : true })
    let body = {
      Email:this.props.location.state.email,
      Code:this.props.location.state.code,
      NewPassword:values.password,
      ConfirmPassword:values.confirm
    }
    resetPassword(
      body,
      (res) => {
        this.Login();
      },
      (error) => {
        //console.log('res', error);
        this.setState({ btnLoading : false });
      });
  };

  Login() {
    let body = {
      Email :  this.props.location.state.email,
      Password :  this.state.newPassword,
    }
    userLogin( 
      body,
      (res) => {
        let data = res?.data?.model;
            this.setState({btnLoading : false})
            localStorage.setItem('tokenCi', data?.Token?.access_token); 
            localStorage.setItem('isAuthenticatedCi', data?.Token?.access_token && true); 
            localStorage.setItem("role",localStorage.getItem("lang")==="ar"? data?.EmployeeType.NameLT: data?.EmployeeType.Name)
            this.props.dispatch(setCurrentUser({...res?.data?.model?.AspNetUsers}))  
            setTimeout(() => { 
                this.props.history.replace("/orders");
            }, 500);
      },
      (error) => {
        if(error.message !== null)
          //message.error("تأكد من صحة البريد الإلكترونى أو كلمة المرور")
        console.error("ERRRR",error.message);  
        this.setState({btnLoading : false})
      }
    );
  }
  
  render() {
    const { btnLoading, isLoginValid } = this.state;
    const { currentLang } = this.props; 

    return ( 
        <div className="auth-wrapper">
          <img src={authBG} className="auth-bg" alt="" />
          <div className="auth-form-content">

              <Link to="/" className="logo-holder">
                <img src={logo} alt="logo" />
              </Link>
              <p className="form-hint-h">
              من فضلك ادخل الرقم السري الجديد
              </p>
            <Form
              name="basic" 
              onFinish={this.onFinish}  
            >
              <Form.Item
                name="password" 
                label={localization.newpassword[currentLang]}
                className="input-holder"
                // rules={[
                //   { required: true, message: `${localization.pleaseInput[currentLang]} ${localization.newpassword[currentLang]}` }, 
                // ]}
                rules={ [
                  {
                      required: true,
                      message: "من فضلك ادخل كلمة المرور الجديد",
                  },
                  {
                      min: 8,
                      message: "يجب ان تكون كلمة المرور أكبر من 8 أحرف",
                  },
                  {
                      max: 20,
                      message: "يجب ان تكون كلمة المرور اقل من 20 حرف",
                     
                  },
                //   {
                //     //Password expresion that requires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces.This is merely an extension of a previously posted expression by Steven Smith(ssmith@aspalliance.com) . The no spaces is new.
                //     pattern: new RegExp(
                //         "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,20})"
                //     ),
                //     message: "يجب أن تحتوي كلمة المرور على حروف كبيرة وأرقام ورموز",
                      
                // },
                ]}
                hasFeedback
              >
                <Input.Password className="input-control" />
              </Form.Item>

              <Form.Item
                name="confirm"
                label={localization.confirmpassword[currentLang]}
                dependencies={['password']} 
                className="input-holder"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "من فضلك ادخل كلمة المرور الجديد",
                },
                {
                    min: 8,
                    message: "يجب ان تكون كلمة المرور أكبر من 8 أحرف",
                },
                {
                    max: 20,
                    message: "يجب ان تكون كلمة المرور اقل من 20 حرف",
                   
                }, 
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(`${localization.Thetwopasswords[currentLang]}`));
                    },
                  }),
                ]}

              >
                <Input.Password className="input-control" />
              </Form.Item>
                <Button size="large" type="primary" htmlType="submit" block loading={btnLoading}>
                  {localization.change[currentLang]} 
                </Button>
            </Form>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
}) 

const LoginWithRouter = withRouter(ResetPassword);
export default connect(mapStateToProps)(LoginWithRouter);